export const JSCALLNO_READY = 1;
export const JSCALLNO_ALERT = 2;
export const JSCALLNO_EXIT = 3;
export const PreDefinedCBID = 1000;

class LeonJSCBTable {
  constructor() {
    this.cbTable = new Map();
  }
  registerCb(id, cb, atOnce) {
    this.cbTable.set(id, { cb: cb, atOnce: atOnce });
  }
  getCb(id) {
    return this.cbTable.get(id);
  }
  isRegisteredCb(id) {
    return null != this.getCb(id);
  }
  callCb(id, message) {
    var cb = this.getCb(id);
    if (cb && cb.cb) {
      if (cb.atOnce) {
        this.unRegisterCb(id);
      }
      return cb.cb(message);
    }
    return '';
  }
  unRegisterCb(id) {
    this.cbTable.delete(id);
  }
}

export const leonJsCBTable = new LeonJSCBTable();

const leonJsCallGateway = (id, message) => {
  if (id) {
    if (JSCALLNO_ALERT === id) {
      if (window.alert) {
        // window.alert(message);
        return '';
      }
    } else {
      return leonJsCBTable.callCb(id, message);
      /*
            var cb = callbackTable.get(id);
            if(cb) {
                callbackTable.delete(id);
                return cb(message);
            }
            */
    }
  }
  return message;
};

const flutterJSCallGateway = leonJsCallGateway;

if (window.flutterJSCallGateway !== flutterJSCallGateway) {
  window.flutterJSCallGateway = flutterJSCallGateway;
}

if (window.leonJsCallGateway != leonJsCallGateway) {
  window.leonJsCallGateway = leonJsCallGateway;
}

if (!window.NativeCallGateway && window.flutter_inappwebview) {
  window.NativeCallGateway = {};
  window.addEventListener('flutterInAppWebViewPlatformReady', function (event) {
    window.NativeCallGateway.postMessage = (msg) =>
      window.flutter_inappwebview.callHandler('NativeCallGateway', msg);
    window.NativeCallGateway.postMessage('ready');
  });
} else if (!window.NativeCallGateway && window.ReactNativeWebView) {
  window.NativeCallGateway = {};
  window.NativeCallGateway.postMessage = (msg) =>
    window.ReactNativeWebView.postMessage(msg);
  const LEONSCRIPT_PREFIX = 'leonevaluatejavascript:';
  const evalJSReturn = 'evalJSReturn';
  const rnMsgHandler = (e) => {
	//alert(e.data);
    if (e && e?.data?.startsWith && e.data.startsWith(LEONSCRIPT_PREFIX)) {
      //window.ReactNativeWebView.postMessage(e.data.substr(LEONSCRIPT_PREFIX.length));
      //window.NativeCallGateway.postMessage('rnMsgHandler');
      const scriptNo = e.data.substr(LEONSCRIPT_PREFIX.length);
      const idx = scriptNo.indexOf(':');
      const script =
        idx < 0
          ? scriptNo
          : scriptNo.substr(idx + (scriptNo.length - 1 > idx ? 1 : 0));
      const id = idx < 0 ? 0 : parseInt(scriptNo.substr(0, idx));
      const ret = eval(script);
      if (0 == id) {
        return;
      } else if (!ret) {
        //ret = ''
      } else {
        //window.alert('>>>>> 1. web app evaluate  : ' + e.data);
        //window.alert('>>>>> 2. web app evaluate result : ' + ret);
      }
      const rpc = {
        jsonrpc: '2.0',
        method: evalJSReturn,
        params: [ret],
        id: id,
      };
      NativeCallGateway.postMessage(JSON.stringify(rpc));
    }
  };

  if (window.document.addEventListener) {
    window.document.addEventListener('message', rnMsgHandler);
  }
  if (window.addEventListener) {
    window.addEventListener('message', rnMsgHandler);
  }
  window.NativeCallGateway.postMessage('ready');
} else if (window.NativeCallGateway) {
  window.NativeCallGateway.postMessage('ready');
}

export const NativeCallGateway = window.NativeCallGateway; 